// TODO: make stateless (had to grab from github, didn't bother forking cause just one file)
/**
 * React Video Thumbnail Component
 * @author mike trieu
 */
import React, { useRef, useState, useEffect } from "react"
import styles from "./css/VideoThumbnail.module.css"
import Measure from "react-measure"
import { Box } from "@chakra-ui/react"

/**
 * Create a canvas and video element to "draw" the
 * image, then convert it to a data url
 */
const getSnapShot = ({
  width,
  videoRef,
  canvasRef,
  setSnapshot,
  thumbnailHandler,
  isSquare,
}) => {
  try {
    const video = videoRef.current
    const canvas = canvasRef.current
    const vidRat = video.videoWidth / video.videoHeight

    const newWidth = isSquare ? width * vidRat : width
    const newHeight = isSquare ? width : width / vidRat

    canvas.height = newHeight
    canvas.width = newWidth

    // resize thumbnail or no ?
    if (!width) {
      canvas.getContext("2d").drawImage(video, 0, 0)
    } else {
      canvas.getContext("2d").drawImage(video, 0, 0, newWidth, newHeight)
    }

    const thumbnail = canvas.toDataURL("image/png")

    // Remove video & canvas elements (no longer needed)
    video.src = "" // setting to empty string stops video from loading
    video.remove()
    canvas.remove()

    setSnapshot(thumbnail)

    // pass the thumbnail url back to parent component's thumbnail handler (if any)
    if (thumbnailHandler) {
      thumbnailHandler(thumbnail)
    }
  } catch (e) {
    console.error(e)
  }
}

/**
 * Simple component that renders thumbnail url
 * @param {string} snapshot
 */
const ThumbnailImage = ({ snapshot, altText }) => {
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#333",
      }}
    >
      {/* <div
        style={{
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          backgroundImage: `url(${snapshot})`,
          backgroundColor: "#fff",
          filter: "blur(8px)",
        }}
      /> */}
      <img
        src={snapshot}
        alt="my video thumbnail"
        style={{ objectFit: "cover", height: "100%", width: "100%" }}
      />
    </div>
  )
}

export const VideoThumbnail = ({
  videoUrl,
  snapshotAtTime = 5,
  thumbnailHandler,
  altText,
  renderThumbnail = true,
  isSquare,
}) => {
  const canvasRef = useRef()
  const videoRef = useRef()
  const [dataLoaded, setDataLoaded] = useState(false)
  const [metadataLoaded, setMetadataLoaded] = useState(false)
  const [seeked, setSeeked] = useState(false)
  const [snapshot, setSnapshot] = useState()
  const [suspended, setSuspended] = useState(false)
  const [containerWidth, setContainerWidth] = useState(0)
  // const [containerHeight, setContainerHeight] = useState(0)

  useEffect(() => {
    videoRef?.current?.setAttribute("crossOrigin", "Anonymous")
  }, [])

  useEffect(() => {
    // check if all 3 required events fired
    if (
      metadataLoaded &&
      dataLoaded &&
      suspended &&
      videoRef.current &&
      containerWidth
    ) {
      if (
        !videoRef.current.currentTime ||
        videoRef.current.currentTime < snapshotAtTime
      ) {
        videoRef.current.currentTime = snapshotAtTime
      }
      if (seeked && !snapshot) {
        // attempt to generate thumbnail
        getSnapShot({
          width: containerWidth,
          videoRef,
          canvasRef,
          setSnapshot,
          thumbnailHandler,
          isSquare,
        })
      }
    }
  }, [
    containerWidth,
    dataLoaded,
    isSquare,
    metadataLoaded,
    seeked,
    snapshot,
    snapshotAtTime,
    suspended,
    thumbnailHandler,
    videoUrl,
  ])

  if (!snapshot) {
    return (
      <Measure
        bounds
        onResize={(contentRect) => {
          const { width, height } = contentRect.bounds
          setContainerWidth(width)
        }}
      >
        {({ measureRef }) => (
          <Box display="flex" height="100%" flex={1} ref={measureRef} bg="#000">
            <canvas
              className={styles["snapshot-generator"]}
              ref={canvasRef}
            ></canvas>
            <video
              preload="metadata"
              muted
              className={styles["snapshot-generator"]}
              ref={videoRef}
              src={videoUrl}
              onLoadedMetadata={() => {
                setMetadataLoaded(true)
                setDataLoaded(true)
              }}
              onLoadedData={() => setDataLoaded(true)}
              onSuspend={() => setSuspended(true)}
              onSeeked={() => setSeeked(true)}
            ></video>
          </Box>
        )}
      </Measure>
    )
  }
  if (renderThumbnail) {
    return <ThumbnailImage snapshot={snapshot} />
  }
  return null
}
